import { useCallback, useState } from 'react';

import { Alert, Modal, ModalProps, Stack } from 'ui';

import { AddStudentForm } from '../../molecules/forms/AddStudentForm';
import { AddStudentSubmit } from '../../molecules/forms/AddStudentSubmit';

interface AddStudentModalProps extends ModalProps {
  openStudentAddedModal: () => void;
}

type AddStudentModalContentProps = {
  openStudentAddedModal: () => void;
};

const AddStudentModalContent = ({ openStudentAddedModal }: AddStudentModalContentProps) => {
  const [error, setError] = useState(false);
  const resetError = useCallback(() => {
    setError(false);
  }, [setError]);

  const _setError = useCallback(() => {
    setError(true);
  }, [setError]);

  return (
    <>
      <Stack>
        <Alert.Collapse type="error" title="We couldn't find a match" in={error}>
          Please check that your student’s name and ID are entered exactly as they appear in school
          records. If the issue continues, contact your school’s office for assistance.
        </Alert.Collapse>
        <AddStudentForm resetError={resetError} />
      </Stack>
      <Modal.AffixedFooter>
        <AddStudentSubmit onSuccess={openStudentAddedModal} setError={_setError} />
      </Modal.AffixedFooter>
    </>
  );
};

const AddStudentModal = ({ openStudentAddedModal, ...props }: AddStudentModalProps) => {
  return (
    <Modal {...props} title="Add Student">
      <AddStudentModalContent openStudentAddedModal={openStudentAddedModal} />
    </Modal>
  );
};

export { AddStudentModal };
